import { gql } from 'apollo-angular';

const GET_OFFER_PRICING_DOWNLOAD = gql`
  query getOfferPricingDownload($id: Long) {
    offerPricingDownload(id: $id) {
      url
    }
  }
`;

export default GET_OFFER_PRICING_DOWNLOAD;
